import React, { SVGProps } from 'react';

export function ActivityIconSVG(props: SVGProps<SVGSVGElement>) {
    return (
        <svg
            width={props?.width ?? 20}
            height={props?.height ?? 20}
            fill="none"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M4.5 18.5h11a2 2 0 002-2v-10l-5-5h-8a2 2 0 00-2 2v13a2 2 0 002 2z"
                stroke="current"
                strokeWidth={1.5}
                strokeLinejoin="round"
            />
            <path
                d="M6 6.5h2.5M6 10.5h8M6 14.5h8"
                stroke="current"
                strokeWidth={1.5}
                strokeMiterlimit={10}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.5 1.5v3a2 2 0 002 2h3"
                stroke="current"
                strokeWidth={1.5}
                strokeLinejoin="round"
            />
        </svg>
    );
}
